export const FINANCIAL_EVIDENCE_TYPES = Object.freeze([
    'TRADE_CONFIRMATION',
    'BROKER_NOTE',
    'BANK_STATEMENT',
    'CUSTODY_STATEMENT',
    'DEPOSITORY_STATEMENT',
    'TAX_CERTIFICATE',
    'DIVIDEND_NOTICE',
    'CORPORATE_ACTION_ANNOUNCEMENT',
    'CLIENT_AGREEMENT',
    'MANDATE_DOCUMENT',
    'VALUATION_EVIDENCE',
    'PRICE_SOURCE_EVIDENCE',
    'APPROVAL_EVIDENCE',
    'RECONCILIATION_EVIDENCE',
    'REGULATORY_ACKNOWLEDGMENT',
    'DELEGATION_EVIDENCE',
]);
export const AI_NON_AUTHORITATIVE_DOMAINS = Object.freeze([
    'VALUATION',
    'HOLDINGS',
    'ACCOUNTING',
    'TAX',
    'REGULATORY_SUBMISSION',
    'ACCESS_DECISION',
    'APPROVAL',
    'ENTITLEMENT',
]);
export function validateFinancialEvidenceDocument(document) {
    const errors = [];
    if (!document.documentId.trim())
        errors.push('documentId is required');
    if (!document.contentHash.trim())
        errors.push('contentHash is required');
    if (!document.retentionPolicyId.trim())
        errors.push('retentionPolicyId is required');
    if (document.version < 1)
        errors.push('version must be positive');
    if (document.scopeKind === 'CLIENT' && !document.clientAccountId)
        errors.push('client-scoped evidence requires clientAccountId');
    if (document.scopeKind === 'PORTFOLIO' && !document.portfolioAccountId)
        errors.push('portfolio-scoped evidence requires portfolioAccountId');
    if (document.scanStatus === 'QUARANTINED' && document.classification === 'CLIENT_VISIBLE')
        errors.push('quarantined evidence cannot be client visible');
    return errors;
}
export function validateFinancialAiAssistanceRecord(record) {
    const errors = [];
    if (!record.modelId.trim())
        errors.push('modelId is required');
    if (!record.modelVersion.trim())
        errors.push('modelVersion is required');
    if (!record.taskVersion.trim())
        errors.push('taskVersion is required');
    if (!record.deterministicFallbackId.trim())
        errors.push('deterministicFallbackId is required');
    if (!record.auditEventId.trim())
        errors.push('auditEventId is required');
    if (record.confidence !== undefined && (record.confidence < 0 || record.confidence > 1))
        errors.push('confidence must be between 0 and 1');
    return errors;
}
